module.exports = __webpack_public_path__ + "static/media/profileIconActive.f71d3447.png";